import React, { useState } from "react";
import styles from "./BusInfoView.module.css";
import { AITP_GRACE_PERIOD_DAYS } from "../../../config";

// doc.expiryDate is the actual/original AITP expiry. Instead of expiring the
// asset immediately, AITP gets a 45-day grace period starting at that expiry.
// "In grace" = now is past the original expiry but still within the 45 days.
const isAITPInGracePeriod = doc => {
  if (!doc?.expiryDate) return false;
  const originalExpiry = new Date(doc.expiryDate).getTime();
  const graceEnd =
    originalExpiry + AITP_GRACE_PERIOD_DAYS * 24 * 60 * 60 * 1000;
  const now = Date.now();
  return now > originalExpiry && now <= graceEnd;
};

const ALL_TABS = [
  {
    key: "INSURANCE",
    label: "Insurance",
    dataKey: "busInsuranceDocumentDetails"
  },
  { key: "POLLUTION", label: "Pollution", dataKey: "pucCertificateDetails" },
  { key: "AITP", label: "AITP", dataKey: "busAITPDocumentDetails" },
  { key: "FITNESS", label: "Fitness", dataKey: "busFitnessCertificateDetails" }
];

const isDocumentValid = doc =>
  !!doc?.documentImageUrl && new Date(doc?.expiryDate) > new Date();

const BusInfoView = ({ data, setEvent }) => {
  const shouldShowTab = tab => {
    const doc = data?.[tab.dataKey];
    // AITP stays visible during its grace period so we can show the
    // "in processing for renewal" message in place of the document.
    if (tab.key === "AITP") {
      return isDocumentValid(doc) || isAITPInGracePeriod(doc);
    }
    return isDocumentValid(doc);
  };
  const TABS = ALL_TABS.filter(shouldShowTab);
  const [activeTab, setActiveTab] = useState(() => TABS[0]?.key ?? "");

  const renderContent = () => {
    switch (activeTab) {
      case "INSURANCE":
        return (
          <div
            className={styles.card}
            style={{
              visibility: isDocumentValid(data?.busInsuranceDocumentDetails)
                ? "visible"
                : "hidden"
            }}
          >
            <img
              src={"" + data?.busInsuranceDocumentDetails?.documentImageUrl}
              alt="insurance"
            />
          </div>
        );

      case "POLLUTION":
        return (
          <div
            className={styles.card}
            style={{
              visibility: isDocumentValid(data?.pucCertificateDetails)
                ? "visible"
                : "hidden"
            }}
          >
            <img
              src={"" + data?.pucCertificateDetails?.documentImageUrl}
              alt="pollution"
            />
          </div>
        );

      case "AITP":
        if (isAITPInGracePeriod(data?.busAITPDocumentDetails)) {
          return (
            <div className={`${styles.card} ${styles.processing}`}>
              <span>AITP document is in processing for renewal</span>
            </div>
          );
        }
        return (
          <div
            className={styles.card}
            style={{
              visibility: isDocumentValid(data?.busAITPDocumentDetails)
                ? "visible"
                : "hidden"
            }}
          >
            <img
              src={"" + data?.busAITPDocumentDetails?.documentImageUrl}
              alt="aitp"
            />
          </div>
        );

      case "FITNESS":
        return (
          <div
            className={styles.card}
            style={{
              visibility: isDocumentValid(data?.busFitnessCertificateDetails)
                ? "visible"
                : "hidden"
            }}
          >
            <img
              src={"" + data?.busFitnessCertificateDetails?.documentImageUrl}
              alt="fitness"
            />
          </div>
        );

      default:
        return null;
    }
  };

  if (TABS.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.fallback}>
          <span>No Information Available</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        {TABS.map(tab => (
          <div
            key={tab.key}
            className={`${styles.tab} ${
              activeTab === tab.key ? styles.activeTab : ""
            }`}
            onClick={() => {
              setActiveTab(tab.key);
              setEvent(tab.label, "INFO");
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {/* Content */}
      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default BusInfoView;
